import httpUtils from '../../utils/HttpUtils'

class AppointmentPriceRecordService {

  async history (appointmentId) {
    var result = null;
    try {
      result = await httpUtils.post('/server/appointment/price/record/history',{appointmentId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  async reject (id) {
    var result = null;
    try {
      console.info('id',id)
      result = await httpUtils.post('/server/appointment/price/record/reject',{id});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new AppointmentPriceRecordService()
